import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Lottie from 'lottie-react';
import downloadAnimation from './download-animation.json'; // You'll provide this
import './pdfDownloadModal.scss';
import apiService from '../../services/api';
import LoginComponent from '../Login';

const PdfDownloadModal = ({ open, onClose, packageId, canDownload, user }) => {
    const [downloading, setDownloading] = useState(false);
    const [downloadType, setDownloadType] = useState(null);

    const handleDownload = async (type, showAnswerInSeparatePage) => {
        if (!user || !user.email) return;

        setDownloading(true);
        setDownloadType(type);

        try {
            const downloadUrl = apiService.packages.getPdfDownloadUrl(packageId, showAnswerInSeparatePage);

            // Create a temporary anchor to trigger download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.click();

            // Small delay to show success state
            setTimeout(() => {
                setDownloading(false);
                setDownloadType(null);
                onClose();
            }, 1500);

        } catch (error) {
            console.error('Download failed:', error);
            setDownloading(false);
            setDownloadType(null);
        }
    };

    const getModalContent = () => {
        // User not logged in
        if (!user || !user.email) {
            return (
                <div className="pdf-download-modal unauthorized">
                    <Box sx={ModalStyle} className="modal-content">
                        <div className="animation-container">
                            <Lottie
                                animationData={downloadAnimation}
                                loop={true}
                                autoplay={true}
                                className="download-lottie"
                            />
                        </div>
                        <Typography variant="h5" className="modal-title">
                            PDF Yuklab Olish
                        </Typography>
                        <Typography className="modal-description">
                            PDF formatda yuklab olish uchun tizimga kiring
                        </Typography>
                        <LoginComponent
                            text={'PDF formatda yuklab olish uchun sahifamizda hisob ochishingiz lozim.'}
                        />
                    </Box>
                </div>
            );
        }

        // User doesn't have download permission
        if (!canDownload) {
            return (
                <div className="pdf-download-modal no-permission">
                    <Box sx={ModalStyle} className="modal-content">
                        <div className="animation-container">
                            <Lottie
                                animationData={downloadAnimation}
                                loop={false}
                                autoplay={true}
                                className="download-lottie"
                            />
                        </div>
                        <Typography variant="h5" className="modal-title">
                            PDF Yuklab Olish
                        </Typography>
                        <Typography className="modal-description error">
                            PDF saqlash tarifi aktivlashmagan!
                        </Typography>
                        <Typography className="modal-subdescription">
                            PDF saqlash tarifini sotib oling
                        </Typography>
                        <div className="action-buttons">
                            <button className="primary-button" onClick={onClose}>
                                Tushunarli
                            </button>
                        </div>
                    </Box>
                </div>
            );
        }

        // Download options
        return (
            <div className="pdf-download-modal options">
                <Box sx={ModalStyle} className="modal-content">
                    <div className="animation-container">
                        <Lottie
                            animationData={downloadAnimation}
                            loop={!downloading}
                            autoplay={true}
                            className={`download-lottie ${downloading ? 'downloading' : ''}`}
                        />
                    </div>

                    <Typography variant="h5" className="modal-title">
                        {downloading ? 'Yuklanmoqda...' : 'PDF Yuklab Olish'}
                    </Typography>

                    {!downloading ? (
                        <>
                            <Typography className="modal-description">
                                Qanday formatda yuklab olishni xohlaysiz?
                            </Typography>

                            <div className="download-options">
                                <div
                                    className="download-option compact"
                                    onClick={() => handleDownload('compact', false)}
                                >
                                    <div className="option-icon">📄</div>
                                    <div className="option-content">
                                        <div className="option-title">
                                            Savol va javobi bir sahifada
                                        </div>
                                        <div className="option-description">
                                            Savol matni va javob ketma-ket joylashgan, bir sahifada
                                        </div>
                                    </div>
                                    <div className="option-arrow">→</div>
                                </div>

                                <div
                                    className="download-option separate"
                                    onClick={() => handleDownload('separate', true)}
                                >
                                    <div className="option-icon">📑</div>
                                    <div className="option-content">
                                        <div className="option-title">
                                            Javoblari alohida sahifada
                                        </div>
                                        <div className="option-description">
                                            Javoblar alohida sahifalarda, oxirida to'plangan
                                        </div>
                                    </div>
                                    <div className="option-arrow">→</div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <Typography className="modal-description loading">
                            {downloadType === 'compact'
                                ? 'Savol va javobi bir sahifada formatida yuklanmoqda...'
                                : 'Javoblari alohida sahifada formatida yuklanmoqda...'
                            }
                        </Typography>
                    )}
                </Box>
            </div>
        );
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="pdf-download-modal"
            aria-describedby="pdf-download-options"
            className="pdf-download-modal-container"
        >
            {getModalContent()}
        </Modal>
    );
};

// Updated ModalStyle for better responsiveness
const ModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 500,
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    outline: 'none'
};

export default PdfDownloadModal;
